export enum StepStatus {
  Wait = 'wait',
  Process = 'process',
  Finish = 'finish',
  Error = 'error'
}